export default __webpack_public_path__ + "static/media/UN Somos Campus 2016-MEDIA-0571.79f03619.jpg";